<template>
  <div class="contert" v-wechat-title="$store.state.region.re_name +'-皖云游-搜索'">
    <newtop :title="'搜索'"></newtop>
    <div class="searcht">
      <van-search
        @search="searchClick"
        shape="round"
        v-model="value"
        show-action
        left-icon=""
        placeholder="请输入目的地关键词"
        @input="inputsearch"
      >
        <template #left>
          <van-dropdown-menu active-color="#e95b2d">
            <van-dropdown-item
              @change="dropdownChange"
              v-model="value1"
              :options="option1"
            />
          </van-dropdown-menu>
        </template>
        <template #action>
          <div @click="onSearch" class="searchimg">
            <img src="@/assets/images/homesearch.png" alt="" />
          </div>
        </template>
      </van-search>
    </div>
    <!-- 搜索结果 -->
     <div class="list-group" v-if="list.length>0">
            <div class="list-group-item" v-for="item in list" :key="item.id">
              <router-link :to="{ name: model, params: { id: item.DicNO } }">
                <van-row>
                  <van-col span="11" class="image">
                    <van-image
                      v-if="item.images.length > 0"
                      radius="5"
                      lazy-load
                      :src="item.images[0]['img_urls']"
                    />
                  </van-col>
                  <van-col span="1"></van-col>
                  <van-col span="12" v-if="model == ''">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">4A级景区</div>
                    <div><span class="tag">山岳峡谷</span></div>
                    <div><span class="price">成人票98元</span></div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'Town'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      
                    </div>
                    <div class="list_v">
                      <div class="name">{{ item.DicName }}</div>
                      <div class="grade">{{ item.Area }}</div>
                    </div>
                    <div class="flex_list" v-if="item.MainScenic">
                      <span
                        class="tag tags"
                        v-for="items in item.MainScenic.split('、')"
                        :key="items.index"
                        ><p>{{ items }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.NearbyScenic }}</span>
                    </div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'Scenic'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.JudgeGrade }}</div>
                    <div class="flex_list" v-if="item.ScenicType">
                      <span
                        class="tag tags"
                        v-for="items in item.ScenicType.split('、')"
                        :key="items.index"
                        ><p>{{ items }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.Historical }}</span>
                    </div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'Village'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.JudgeGrade }}</div>
                    <div class="flex_list" v-if="item.MainScenic">
                      <span
                        class="tag tags"
                        v-for="items in item.MainScenic.split('、')"
                        :key="items.index"
                        ><p>{{ items }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.Honour }}</span>
                    </div>
                  </van-col>
                  <van-col
                    span="12"
                    v-else-if="model == 'Hotel' || model == 'Restaurant'"
                  >
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.JudgeGrade }}</div>
                    <div>
                      <span class="tag tags"
                        ><p>{{ item.Telphone }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.MaxLoad }}</span>
                    </div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'Food'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.Taste }}</div>
                    <div class="flex_list" v-if="item.FoodType">
                      <span
                        class="tag tags"
                        v-for="items in item.FoodType.split('、')"
                        :key="items.index"
                        ><p>{{ items }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.MarketPrice }}</span>
                    </div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'Celebritie'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.Positional }}</div>
                    <div>
                      <span class="tag tags"
                        ><p>{{ item.ByDynasty }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.Feats }}</span>
                    </div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'NonHeritage'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.Honour }}</div>
                    <div>
                      <span class="tag tags"
                        ><p>{{ item.JudgeGrade }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.Inheritor }}</span>
                    </div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'Commoditie'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.QualityFeature }}</div>
                    <div>
                      <span class="tag tags"
                        ><p>{{ item.FoodType }}</p></span
                      >
                    </div>
                    <div>
                      <span class="price">{{ item.MarketPrice }}</span>
                    </div>
                  </van-col>
                  <van-col span="12" v-else-if="model == 'Argumentation'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.JudgeGrade }}</div>
                    <div>
                      <span class="tag">{{ item.atype.join(",") }}</span>
                    </div>
                    <div>
                      <span class="price">{{ item.MaxLoad }}</span>
                    </div>
                  </van-col>

                  <van-col span="12" v-else-if="model == 'Seastella'">
                    <div class="identify">
                      ID:{{ item.DicNO }}
                      <span v-if="item.town" class="identify-span"
                        ><van-icon name="location" size="14" />{{
                          item.town.RegionName
                        }}</span
                      >
                    </div>
                    <div class="name">{{ item.DicName }}</div>
                    <div class="grade">{{ item.atype.join(",") }}</div>
                    <div>
                      <span class="tag">{{ item.Money }}</span>
                    </div>
                    <div>
                      <span class="price">{{ item.Join }}</span>
                    </div>
                  </van-col>
                </van-row>
              </router-link>
            </div>
          </div>
    <div class="search_center" v-else style="padding-top:110px">
        <p>搜索指定内容</p>
        <div class="xuanzhongt">
            <span @click="checkClick(item)" v-for="item in option1" :key="item.value">{{item.text}}</span>
        </div> 
        <div class="zanwu">
        <img src="@/assets/images/zanwu.png" alt="">
        暂无搜索数据
        </div>
    </div>
    <fanhui-top></fanhui-top>
  </div>
</template>
<script>
import newtop from "../components/travel/newTop.vue";
import fanhuiTop from "@/components/fanhuiTop";
import { travelList } from "@/api/travel";
export default {
  data() {
    return {
      value1: "Scenic",
      value: "",
      option1: [
        { text: "旅游景区", value: "Scenic" },
        { text: "乡村旅游", value: "Village" },
        { text: "文体场馆", value: "Argumentation" },
        { text: "旅游住宿", value: "Hotel" },
        { text: "餐饮农家乐", value: "Restaurant" },
        { text: "特色美食", value: "Food" },
        { text: "历史名人", value: "Celebritie" },
        { text: "文化非遗", value: "NonHeritage" },
        { text: "旅游商品", value: "Commoditie" },
        { text: "旅游乡镇", value: "Town" },
        { text: "文旅项目", value: "Seastella" }
      ],
      list: [],
    };
  },
  methods: {
    // 选择触发
    dropdownChange(e) {
        this.model = e;
    },
    // 回车触发
    searchClick(e) {
      console.log(e);
    },
    //点击搜索触发
    onSearch() {
        if(this.value!=''){
            this.searchlist(this.value)
        }
    },
    //搜索框值改变时触发
    inputsearch(e) {
    //console.log(e);
    if(e!=''){
      this.searchlist(e)
      return
    }
    this.list = []
    },
    searchlist(item){
    travelList({
      model: this.value1,
      id: this.$route.params.id,
      keywords: item,
    })
      .then((res) => {
        this.list = res.list.data;
      })
      .catch((err) => {
      });
    },
    checkClick(item){
        this.value1 = item.value
        console.log(item);
    }
  },
  components: {
    newtop,
    fanhuiTop
  },
  created() {
      this.model = this.value1
  },
};
</script>
<style >
.searcht .van-dropdown-menu__bar {
  box-shadow: none !important;
}
.searcht .van-dropdown-menu .van-cell {
  padding: 10px 16px;
}
.searcht .van-dropdown-item__content {
    position: absolute;
    max-height: 90%;
}
</style>
<style scoped>
.zanwu{
    margin-top: 20%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #afafaf;
}
.zanwu img{
    width: 100px;
    margin-bottom: 10px;
}
.xuanzhongt{
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
}
.search_center p{
    display: block;
    color: rgb(27, 14, 14);
    font-size: 14px;
    text-align: center;
    margin-bottom: 10px;
}
.xuanzhongt span{
    width: 33%;
    text-align: center;
    margin-bottom: 10px;
    color: #e95b2d;
    font-size: 14px;
}
.contert {
  width: 100%;
  height: 100vh;
}
.searcht {
  padding-top: 44px;
  display: flex;
  position: fixed;
  z-index: 1;
  left: 0;
  right: 0;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
}
.searcht .van-search {
  flex: 1;
  padding: 2px 0;
}
.van-dropdown-menu {
  flex: 0.4;
}
.searchimg img {
  width: 20px;
  height: 20px;
}

.list-travel .van-nav-bar {
  background-color: rgba(43, 178, 240, 1);
  color: #fff;
}
.list-travel .van-nav-bar__text,
.list-travel .van-nav-bar .van-icon {
  color: #fff;
  font-size: 16px;
}
.list-travel .van-nav-bar__title {
  color: #fff;
  font-size: 18px;
}
.flex_list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-height: 46px;
  overflow: hidden; /*超出部分隐藏*/
  align-items: center;
}

.tags {
  width: auto;
  border: 1px solid rgb(234, 85, 23);
  margin-right: 6px;
  margin-bottom: 4px;
  padding: 0 2px;
  display: inline-block;
  box-sizing: border-box;
}
.tags p {
  margin-top: 2px;
}
.ff {
  display: flex;
  align-items: center;
}

.identify-span {
  float: right;
  color: #333;
}
.list-travel {
  background-color: #fff;
  /* position: fixed; */
}
.carousel {
  border-radius: 0.5em;
  /*height: 110px;*/
}
.van-tag {
  background-color: #ea5517;
}
.van-row {
  display: flex;
  align-items: center;
  justify-content: center;
}
.van-col--1 {
  width: 2%;
}
.van-col {
  display: flex;
  flex-direction: column;
}

.tag {
  font-size: 10px;
  color: rgb(234, 85, 23);
}
.price {
  font-size: 12px;
  color: #555;
}
.identify {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: rgb(241, 91, 26);
}

.name {
  font-family: "Microsoft YaHei";
  font-size: 14px;
  font-weight: bold;
  color: black;
}

.grade {
  font-size: 12px;
  color: #777;
}
.list-group{
    padding-top: 96px;
}
.list-group-item {
  background: #fff;
  padding: 5px 10px;
  border-bottom: 5px solid #f7f7f7;
}
</style>